import { URL_Type } from 'shared/utils/Constants';
import { http_delete, http_get, http_post } from './BaseURLAxios';
import { LOGIN_URL, FORGOT_PASSWORD_URL, RESET_PASSWORD_URL, LOGOUT_URL, GOOGLE_LOGIN_URL, MFA_SETUP_URL, MFA_VERIFY_URL, MFA_SETUP_VERIFY_URL, MFA_RECOVERY, MFA_FORGOT_VERIFY } from './urlConstants';

export const onLoginAPI = async (body: any) => {
    return http_post(LOGIN_URL, body).then((res: any) => {
        return res;
    });
};

export const onForgotPasswordAPI = async (email: string) => {
    return http_get(FORGOT_PASSWORD_URL + '/' + email).then((res: any) => {
        return res;
    });
};

export const onResetPasswordAPI = async (
    body: { new_pwd: string; is_verified: boolean; url: string; type: URL_Type },
    token: string,
) => {
    const config = { headers: { Authorization: `Bearer ${token}` } };

    return http_post(RESET_PASSWORD_URL, body, config).then((res: any) => {
        return res;
    });
};
export const onGoogleLoginAPI = async (body: { token?: string; code?: string }) => {
    return http_post(GOOGLE_LOGIN_URL, body).then((res: any) => {
        return res;
    });
};

export const onLogoutAPI = async () => {
    return http_delete(LOGOUT_URL).then((res: any) => {
        return res;
    });
};

export const onMFASetupAPI = async () => {
    return http_get(MFA_SETUP_URL).then((res: any) => {
        return res;
    });
};

export const onMFAVerifyAPI = async (body: { code: string }) => {
    return http_post(MFA_VERIFY_URL, body).then((res: any) => {
        return res;
    });
};
export const onMFASetupVerifyAPI = async (body: { code: string }) => {
    return http_post(MFA_SETUP_VERIFY_URL, body).then((res: any) => res);
};
export const onForgotMFARecoveryAPI = async (body:{email: string}) => {
    return http_post(MFA_RECOVERY , body).then((res: any) => {
        return res;
    });
};
export const forgotMFAAPI = async (body: { code: string }) => {
    return http_post(MFA_FORGOT_VERIFY, body).then((res: any) => res);
};